<div class="activity-details solo" ng-show="newIssue.show">
    <c-auto-form config="newIssue.autoFormConfig"></c-auto-form>
</div>